export const APP_LOADING_BEGIN = 'APP_LOADING_BEGIN';
export const APP_LOADING_END = 'APP_LOADING_END';
export const TOGGLE_COLLAPSED = 'TOGGLE_COLLAPSED';
export const CHANGE_HEADER_TITLE = 'CHANGE_HEADER_TITLE';
